var _defs, _rect, _g, _defs2, _defs3, _defs4, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinxaiLogoSvgOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 2426.437207025662,
    viewBox: "133.68799575805664 88.28810104370118 72.6238101196289 73.42379791259765",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "imagesvg isNoFont",
    transform: "translate(140.39999771118164,95.00009727478027)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#256cfcda-079f-4146-aa3f-9d7a7bdf38df)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0619",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 59.20000705295199,
    height: 59.9998044462201,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 59.20000705295199,
    height: 59.9998044462201,
    filtersec: "colorsf2796579458",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "5.599999904632568 4.999999046325684 88.80000305175781 89.99999237060547",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "d-rs": 1,
    transform: "matrix(0,1,-1,0,100,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 24.5,
    r: 18.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.7,
    cy: 58.2,
    r: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 25.9,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.9,
    cy: 42.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.2,
    cy: 54.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.1,
    cy: 58.4,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.6,
    cy: 80.7,
    r: 12.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4,
    cy: 83.1,
    r: 11.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 56.1,
    r: 14.3
  }))))), /*#__PURE__*/React.createElement("rect", {
    "v-gra": "id",
    width: 71.19981384277344,
    height: 71.99980545043945,
    transform: "translate(-6, -6)",
    style: {
      pointerEvents: "none"
    },
    fill: "url(#v-ZMAtnciVjd0iZV0omsC)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7159040261"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8984375  0 0 0 0 0.56640625  0 0 0 0 0.21875  0 0 0 1 0",
    className: "icon-feColorMatrix "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf2796579458"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb2267052879"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "id"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "dab55bdb-214c-4cda-a166-1c4a6b854cf7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0,
    id: "v-ZMAtnciVjd0iZV0omsC"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#57ec99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33.33%",
    stopColor: "#1371ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66.67%",
    stopColor: "#fc1cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fccc05"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "42443b3f1de60f6b6fd3b6a9844b4764",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    "v-gra": "im",
    id: "256cfcda-079f-4146-aa3f-9d7a7bdf38df"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    filter: "url(#dab55bdb-214c-4cda-a166-1c4a6b854cf7)",
    x: 0,
    y: 0,
    width: 59.20000705295199,
    height: 59.9998044462201,
    filtersec: "colorsf2796579458",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "5.599999904632568 4.999999046325684 88.80000305175781 89.99999237060547",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "d-rs": 1,
    transform: "matrix(0,1,-1,0,100,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 24.5,
    r: 18.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.7,
    cy: 58.2,
    r: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 25.9,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.9,
    cy: 42.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.2,
    cy: 54.7,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.1,
    cy: 58.4,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.6,
    cy: 80.7,
    r: 12.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4,
    cy: 83.1,
    r: 11.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 56.1,
    r: 14.3
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinxaiLogoSvgOnly);
export default __webpack_public_path__ + "static/media/finxai_logo_svg_only.f3beab422c010bef8035bb0fcde810ca.svg";
export { ForwardRef as ReactComponent };